import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import * as english from './en'
import * as spanish from './es'

// the translations
const resources = {
  en: english,
  es: spanish
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
